import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

import WelcomeHero from './components/WelcomeHero';
import AssessmentBenefits from './components/AssessmentBenefits';
import TrustIndicators from './components/TrustIndicators';
import PrivacyAssurance from './components/PrivacyAssurance';

const AssessmentWelcome = () => {
  const [showLearnMore, setShowLearnMore] = useState(false);

  const assessmentFeatures = [
    // {
    //   icon: "Clock",
    //   title: "Quick & Efficient",
    //   description: "Complete assessment in 10-15 minutes",
    //   color: "primary"
    // },
      {
      icon: "Target",
      title: "Personalized Results",
      description: "Get tailored recommendations for your wellness",
      color: "accent"
    },
 
  
    {
      icon: "Users",
      title: "Expert Validated",
      description: "Developed with healthcare professionals",
      color: "primary"
    },
       {
      icon: "Shield",
      title: "Privacy Protected",
      description: "Your data is encrypted and secure",
      color: "secondary"
    }
  ];

  const detailedMethodology = `Our Wellness and Anxiety Assessment uses evidence-based screening tools developed in collaboration with mental health professionals and public health experts. The assessment evaluates multiple dimensions of wellness including mental health symptoms, lifestyle changes, physical health indicators, and social factors that may have been impacted by the pandemic.

Your responses are analyzed using validated psychological screening instruments and compared against established wellness benchmarks. The personalized recommendations you receive are based on clinical guidelines and best practices for managing anxiety, stress, and overall wellness during challenging times.

All data is processed securely and in compliance with healthcare privacy standards. Your individual responses remain confidential and are used solely to generate your personalized wellness report.`;

  return (
    <div className="min-h-screen bg-background">
      {/* Header with Progress */}
      <div className="bg-surface border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-6">
               <img src="public/assets/images/apollo-logo-new.png" className="flex items-center justify-center w-17 h-12"></img>
            <div>
              <h1 className="text-xl font-heading font-semibold text-text-primary">
                Wellness and Anxiety Evaluation
              </h1>
              <p className="text-sm font-caption text-text-secondary"></p>
            </div>
            </div>
            
            <div className="hidden md:flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-primary rounded-full"></div>
                <span className="text-sm text-text-secondary">Step 1 of 3</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left Column - Hero Content */}
          <div className="space-y-8">
            <WelcomeHero />
            
            {/* Mobile Benefits - Show on mobile only */}
            <div className="lg:hidden">
              <AssessmentBenefits features={assessmentFeatures} />
            </div>
          </div>

          {/* Right Column - Benefits & Trust Signals */}
          <div className="space-y-8">
            {/* Desktop Benefits - Show on desktop only */}
            <div className="hidden lg:block">
              <AssessmentBenefits features={assessmentFeatures} />
            </div>
            
            {/* <PrivacyAssurance /> */}
            {/* <TrustIndicators /> */}
          </div>
        </div>

        {/* Action Section */}
        <div className="mt-12 text-center">
          <div className="max-w-2xl mx-auto space-y-6">
            <div className="bg-primary-50 border border-primary-100 rounded-xl p-6">
              <div className="flex items-center justify-center space-x-3 mb-4">
                <Icon name="Info" size={20} color="var(--color-primary)" />
                <h3 className="font-heading font-medium text-primary-600">
                  Ready to Begin Your Wellness Assessment?
                </h3>
              </div>
              <p className="text-sm text-primary-600 mb-6">
                Take the first step towards understanding your wellness and getting personalized recommendations for better mental health.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/multi-step-assessment-form"
                  className="btn-primary inline-flex items-center justify-center space-x-2 px-8 py-4 text-lg"
                >
                  <Icon name="Play" size={20} />
                  <span>Start Assessment</span>
                </Link>
                
                <button
                  onClick={() => setShowLearnMore(!showLearnMore)}
                  className="inline-flex items-center justify-center space-x-2 px-6 py-4 bg-surface border border-border rounded-lg text-text-primary font-medium hover:bg-surface-secondary transition-all duration-200"
                >
                  <Icon name="BookOpen" size={20} />
                  <span>Learn More</span>
                </button>
              </div>
            </div>

            {/* Detailed Methodology - Progressive Disclosure */}
            {showLearnMore && (
              <div className="bg-surface border border-border rounded-xl p-6 text-left">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-heading font-semibold text-text-primary">
                    Assessment Methodology
                  </h3>
                  <button
                    onClick={() => setShowLearnMore(false)}
                    className="p-1 text-text-secondary hover:text-text-primary transition-colors duration-150"
                  >
                    <Icon name="X" size={20} />
                  </button>
                </div>
                <div className="prose prose-sm max-w-none text-text-secondary">
                  <p>{detailedMethodology}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-surface border-t border-border mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="text-center">
            <p className="text-sm text-text-secondary">
              © {new Date().getFullYear()} Wellness Anxiety Scanner. Developed for wellness support.
            </p>
            <div className="flex items-center justify-center space-x-6 mt-4">
              <a href="#" className="text-sm text-text-secondary hover:text-text-primary transition-colors duration-150">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-text-secondary hover:text-text-primary transition-colors duration-150">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-text-secondary hover:text-text-primary transition-colors duration-150">
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentWelcome;